
import { Component, Vue } from 'vue-property-decorator';
import _ from 'lodash';
import { mainStore, userToolStore, userActionStore } from '../../../utils/store-accessor';

@Component
export default class RoutesMetas extends Vue {
  get isDashboardRoute() {
    return this.currentRoute == '/main/metas/dashboard';
  }

  get isComissionamentoRoute() {
    return this.currentRoute == '/main/bonificacaometa';
  }

  get isBonificacaoRoute() {
    return this.currentRoute == '/main/bonificacaometa/aprovados';
  }

  get isMetasRoute() {
    return this.currentRoute == '/main/metas/all';
  }

  get usertools() {
    return userToolStore.currentUserTools;
  }
  get allowViewMetas() {
    let tool = _.find(this.usertools, (x) => x.tool_id == 12);

    if (!tool) return false;
    return tool.allow_view;
  }

  get userActions() {
    return userActionStore.userActions;
  }

  get allowSeeAllBonificacoes() {
    let action = this.userActions.find((x) => x.action_id == 40);

    if (!action) return false;

    return action.allow;
  }

  get currentUserComissaoTools() {
    return (
      userToolStore.currentUserTools.find((t) => t.tool_id === 71) || {
        allow_view: false,
        allow_create: false,
        allow_delete: false,
        allow_edit: false,
      }
    );
  }

  get currentRoute() {
    return this.$route.path;
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  public async mounted() {}
}
